<template>
  <div class="stList">
    <list
      row-key="StudentId"
      ref="list"
      unit="学生信息"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="学校名称">
          <el-select size="mini" v-model="params.SchoolId" clearable @change="query()">
            <el-option v-for="item in schoolList" :key="item.SchoolId" :value="item.SchoolId" :label="item.SchoolName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学生姓名">
          <el-input size="mini" v-model="params.FullName" placeholder="请输入学生姓名" clearable />
        </el-form-item>
        <el-form-item label="学生编号">
          <el-input size="mini" v-model="params.StudentNumber" placeholder="请输入学生编号" clearable />
        </el-form-item>
        <el-form-item label="家长电话">
          <el-input size="mini" v-model="params.ContactNumber" placeholder="请输入家长电话" clearable />
        </el-form-item>
        <el-form-item label="卡号">
          <el-input size="mini" v-model="params.CardNumber" placeholder="请输入卡号" clearable />
        </el-form-item>
        <el-form-item label="宿舍号">
          <el-input size="mini" v-model="params.DormitoryNo" placeholder="请输入宿舍号" clearable />
        </el-form-item>
        <el-form-item label="账号状态">
          <el-select size="mini" v-model="params.Status" clearable>
            <el-option value="1" label="有效"/>
            <el-option value="0" label="无效"/>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <!-- <el-table-column prop="TermName" label="学期" min-width="130px" /> -->
        <template v-if="isMB">
          <el-table-column prop="SchoolName" label="学校名称" min-width="140"/>
          <el-table-column prop="StudentNumber" label="学生编号" min-width="120px" />
          <el-table-column prop="FullName" label="姓名" min-width="80px" fixed="left" />
          <el-table-column prop="CardNumber" label="卡号" min-width="120px" />
          <el-table-column prop="Status" label="账号状态" width="80">
            <template slot-scope="{row}">
              <span v-if="row.Status===0">无效</span>
              <span v-else-if="row.Status===1">有效</span>
            </template>
          </el-table-column>
        </template>
        <template v-else>
          <el-table-column prop="SchoolName" label="学校名称" min-width="140" fixed="left" />
          <el-table-column prop="StudentNumber" label="学生编号" min-width="120px" fixed="left" />
          <el-table-column prop="FullName" label="姓名" min-width="80px" fixed="left" />
          <el-table-column prop="CardNumber" label="卡号" min-width="120px" fixed="left" />
          <el-table-column prop="Status" label="账号状态" width="80" fixed="left">
            <template slot-scope="{row}">
              <span v-if="row.Status===0">无效</span>
              <span v-else-if="row.Status===1">有效</span>
            </template>
          </el-table-column>
        </template>
        <el-table-column prop="DormitoryNo" label="宿舍号" min-width="100px" />
        <!-- <el-table-column prop="CurrentSeatNumber" label="当前座位号" min-width="120px" /> -->
        <!-- <el-table-column prop="CurrentClassName" label="当前班级" min-width="110px" /> -->
        <el-table-column prop="ParentName1" label="家长姓名1" min-width="80px" />
        <el-table-column prop="Alias1" label="称呼1" min-width="80px" />
        <el-table-column prop="ContactNumber1" label="联系电话1" min-width="120px" />
        <el-table-column prop="ParentName2" label="家长姓名2" min-width="80px" />
        <el-table-column prop="Alias2" label="称呼2" min-width="80px" />
        <el-table-column prop="Call2" label="联系电话2" min-width="120px" />
        <el-table-column prop="ParentName3" label="家长姓名3" min-width="80px" />
        <el-table-column prop="Alias3" label="称呼3" min-width="80px" />
        <el-table-column prop="ContactNumber3" label="联系电话3" min-width="120px" />
        <el-table-column prop="InDate" label="入学日期" width="100">
          <template slot-scope="{row}">
            {{ $commonJs.toDateString(row.InDate) }}
          </template>
        </el-table-column>
        <el-table-column prop="ShortNum" label="学生短号" width="90"/>
        <el-table-column prop="Balance" label="充值余额" width="90"/>
        <el-table-column prop="GiveBalance" label="赠送金额" width="90"/>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <export-dialog ref="exportDialog" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import exportDialog from "./exportDialog";

export default {
  mixins: [listMixin],
  components: { list, exportDialog },
  props: {
    showCheckbox: {
      type: Boolean,
      default: true,
    },
  },
  beforeMount() {
    this.schoolApi.list({ Status: 1 }).then(res => {
      if(res.Code == 0) {
        this.schoolList = res.Data;
        // if(res.Data.length>0) {
        //   this.params.SchoolId = res.Data[0].SchoolId;
        // }
      }
    })
  },
  data() {
    return {
      api: require("@/api/st/student").default,
      schoolApi: require("@/api/st/school").default,
      params: {
        SchoolId: null,
        FullName: "",
        StudentNumber: "",
        ContactNumber: "",
        CardNumber: "",
        DormitoryNo: "",
        Status:null
      },
      isMB: this.$store.state.isMB,
      schoolList: [],
    };
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    export() {
      // this.$refs.exportDialog.open().then((that) => {
      //   that.getData(this.params);
      // });
      this.api.export(this.$commonJs.obj.removeNullKey(this.$refs.list.tempQueryParams));
    },
  },
};
</script>
<style lang="scss" scoped> 
@media screen and (min-width: 768px){
  .stList{
    /deep/ .el-table > .el-table__fixed {
      height: calc(100% - 17px) !important;
    }
  }
}
</style>